import React from "react";

const OUT = { verified: ["Verified match", "bg-emerald-50 text-emerald-700"], possible: ["Possible match", "bg-amber-50 text-amber-800"], no_match: ["No match", "bg-slate-100 text-slate-600"] };
const LINK = { approved: ["Linked", "bg-emerald-600 text-white"], rejected: ["Rejected", "bg-rose-50 text-rose-700"], new_catalogue_item: ["New catalogue item", "bg-indigo-600 text-white"], none: ["Awaiting decision", "bg-white text-slate-500 border"] };

export function OutcomeBadge({ m, testId }) {
  const [label, tone] = OUT[m.outcome] || [m.outcome, ""];
  return <span className={`text-[11px] font-semibold px-2 py-0.5 rounded ${tone}`} data-testid={testId}>{label}{m.duplicate ? " · duplicate" : ""}</span>;
}

export function LinkBadge({ link, testId }) {
  const [label, tone] = LINK[link.status] || [link.status, ""];
  return <span className={`text-[11px] font-semibold px-2 py-0.5 rounded ${tone}`} data-testid={testId}>{label}{link.tedops_legacy_id ? ` → TedOps ${link.tedops_legacy_id}` : ""}</span>;
}

export const money = (v) => (v || v === 0 ? `£${Number(v).toFixed(2)}` : "—");

export function offerLabel(o) {
  return o.wc_variation_id ? `Variant ${o.wc_variation_id}${o.attributes?.length ? ` · ${o.attributes.join(", ")}` : ""}` : "Product";
}
